import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import api from '../../../services/api';
import { getSubdomainUsername, getUsernameSyncOnly } from '../../../utils/subdomain';

const PublicStats = () => {
  const { username: urlUsername } = useParams();
  const subdomainUser = getSubdomainUsername();
  const cachedCustomDomainUser = getUsernameSyncOnly();
  const username = urlUsername || subdomainUser || cachedCustomDomainUser;

  const [data, setData] = useState({ section: null, stats: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await api.get(`/business/stats/public/${username}/`);
        // API returns object with section and items
        const stats = Array.isArray(res.data) ? res.data : (res.data.stats || res.data.items || []);
        setData({
          section: res.data.section || {},
          stats: stats
        });
      } catch (err) {
        console.error('Error fetching stats:', err);
      } finally {
        setLoading(false);
      }
    };
    if (username) fetchData();
  }, [username]);

  if (loading) {
    return (
      <div style={{ padding: '4rem 2rem', textAlign: 'center' }}>
        <div style={{
          width: '2rem', height: '2rem',
          border: '3px solid rgba(255,255,255,0.1)',
          borderTopColor: '#6366f1',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          margin: '0 auto'
        }} />
      </div>
    );
  }

  if (!data.stats.length) {
    return (
      <div id="section-stats" style={{ padding: '4rem 2rem', textAlign: 'center', backgroundColor: '#0f172a' }}>
        <p style={{ color: 'rgba(255,255,255,0.5)' }}>No stats available yet.</p>
      </div>
    );
  }

  return (
    <div style={{
      padding: '4rem 2rem',
      background: 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)'
    }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        {data.section?.title && (
          <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
            <h2 style={{ fontSize: '2.5rem', fontWeight: '700', color: '#fff', marginBottom: '0.5rem' }}>
              {data.section.title}
            </h2>
            {data.section?.subtitle && (
              <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '1.1rem' }}>
                {data.section.subtitle}
              </p>
            )}
          </div>
        )}

        <div style={{
          display: 'grid',
          gridTemplateColumns: `repeat(${Math.min(data.stats.length, 4)}, 1fr)`,
          gap: '2rem'
        }}>
          {data.stats.map((stat, index) => (
            <div
              key={stat.id || index}
              style={{
                textAlign: 'center',
                padding: '2rem'
              }}
            >
              {stat.icon && (
                <span style={{ fontSize: '2.5rem', marginBottom: '0.5rem', display: 'block' }}>
                  {stat.icon}
                </span>
              )}
              <div style={{
                fontSize: '3rem',
                fontWeight: '700',
                color: '#6366f1',
                marginBottom: '0.5rem'
              }}>
                {stat.prefix || ''}{stat.value}{stat.suffix || ''}
              </div>
              <div style={{
                color: '#fff',
                fontSize: '1.1rem',
                fontWeight: '500'
              }}>
                {stat.label || stat.title}
              </div>
              {stat.description && (
                <p style={{
                  color: 'rgba(255,255,255,0.5)',
                  fontSize: '0.875rem',
                  marginTop: '0.5rem'
                }}>
                  {stat.description}
                </p>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PublicStats;
